"use client";

import { useSyncExternalStore } from "react";

let hydrated = false;
const listeners = new Set<() => void>();

function subscribe(fn: () => void) {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

function getSnapshot() {
  return hydrated;
}

function getServerSnapshot() {
  return false;
}

export function markFeedSearchHeaderPortalHostsHydrated() {
  if (hydrated) return;
  hydrated = true;
  listeners.forEach((fn) => fn());
}

export function resetFeedSearchHeaderPortalHostsHydrated() {
  if (!hydrated) return;
  hydrated = false;
  listeners.forEach((fn) => fn());
}

export function useFeedSearchHeaderPortalHostsHydrated() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
